import { message } from 'ant-design-vue'
/**
 * 错误拦截器：请求异常时，对异常错误码统一提示
 *
 * @since 1.0.0
 * @version 1.0.0
 */

// 消息提示数组
let TOAST = {}

/**
 * 错误拦截器：请求异常时，对异常错误码统一提示
 *
 * @param {object} body - 响应体
 * @returns {boolean} - 返回false,可提前退出
 */
export default function toastErrorInterceptor(body) {
  console.log('body.data[message]', body.data['message'])
  if (!body.config.meta.showToast) {
    return false
  }
  if (!TOAST[body.data['message']]) {
    if (
      body.data['message'] != 'A0327' &&
      body.data['code'] != 'A0327' &&
      body.data['code'] != '790086' &&
      body.data['code'] != '790085' &&
      body.data['code'] != '840001' &&
      body.data['code'] != '790090' &&
      body.data['code'] != '790092' &&
      body.data['code'] != '790093' &&
      body.data['code'] != 'GBC001'
    )
      message.error(body.data['message'])
    TOAST[body.data['message']] = true
    let timeOutId = setTimeout(() => {
      delete TOAST[body.data['message']]
      clearTimeout(timeOutId)
    }, 1000)
  }

  return true
}
